import { useEffect, useState } from 'react';

const STATS_ACCESS_KEY = 'portfolio_stats_access';
const STATS_QUERY = 'stats';
const STATS_SECRET = process.env.REACT_APP_STATS_KEY || 'wow';

function readStatsAccess() {
  if (typeof window === 'undefined') {
    return false;
  }

  if (localStorage.getItem(STATS_ACCESS_KEY) === '1') {
    return true;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get(STATS_QUERY) === STATS_SECRET;
}

export function useStatsAccess() {
  const [hasAccess, setHasAccess] = useState(readStatsAccess);

  useEffect(() => {
    if (readStatsAccess()) {
      localStorage.setItem(STATS_ACCESS_KEY, '1');
      setHasAccess(true);
    }
  }, []);

  return hasAccess;
}
